var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button-loading jda-btn",attrs:{"disabled":_vm.disabled},on:{"click":_vm.click}},[_vm._v("\n  "+_vm._s(_vm.content)+"\n  "),(_vm.status == 'loading')?_c('div',{staticClass:"loader"}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }